var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAggregateResponses01 = function SvgAggregateResponses01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aggregate_responses-01_svg2__a",
    x1: 58.48,
    x2: 231.28,
    y1: 215.45,
    y2: 86.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#aggregate_responses-01_svg2__a",
    id: "aggregate_responses-01_svg2__b",
    x1: 39.61,
    x2: 212.41,
    y1: 190.13,
    y2: 61.38
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#aggregate_responses-01_svg2__a",
    id: "aggregate_responses-01_svg2__c",
    x1: -0.88,
    x2: 171.92,
    y1: 135.78,
    y2: 7.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#aggregate_responses-01_svg2__a",
    id: "aggregate_responses-01_svg2__d",
    x1: 0.02,
    x2: 172.82,
    y1: 137,
    y2: 8.24
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "27 All Mail"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.57 66.64a3.123 3.123 0 1 0-1.52 6.06c1.78.45 3.39 1.38 4.71 2.71 1.93 1.93 2.99 4.49 2.99 7.2v79.91c0 5.65-4.58 10.25-10.22 10.25H61.66c-4.71 0-8.78-3.16-9.9-7.69-.42-1.68-2.12-2.68-3.79-2.28a3.13 3.13 0 0 0-2.28 3.79c1.82 7.32 8.39 12.43 15.97 12.43h121.88c9.08 0 16.47-7.4 16.47-16.5V82.61c0-4.38-1.71-8.51-4.8-11.6-2.1-2.14-4.74-3.65-7.63-4.37Z",
    style: {
      fill: "url(#aggregate_responses-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 139.96V60.05c0-4.4-1.71-8.54-4.82-11.65-2.15-2.16-4.81-3.65-7.68-4.33-1.7-.38-3.36.64-3.76 2.32s.64 3.36 2.32 3.76c1.74.41 3.36 1.33 4.7 2.67 1.93 1.92 2.99 4.49 2.99 7.22v79.91c0 5.65-4.58 10.25-10.22 10.25H39.06c-4.71 0-8.78-3.16-9.9-7.69-.42-1.68-2.12-2.68-3.79-2.28a3.13 3.13 0 0 0-2.28 3.79c1.82 7.32 8.39 12.43 15.97 12.43h121.91c9.08 0 16.47-7.4 16.47-16.5Z",
    style: {
      fill: "url(#aggregate_responses-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.86 117.39V37.48c0-4.4-1.71-8.54-4.8-11.62a16.3 16.3 0 0 0-11.67-4.87H16.5C7.47 20.98 0 28.31 0 37.48v79.91c0 9.1 7.4 16.5 16.5 16.5h121.89c9.08 0 16.47-7.4 16.47-16.5m-148.61 0V37.48c0-5.65 4.61-10.25 10.25-10.25h121.89c2.74 0 5.3 1.07 7.24 3.03 1.92 1.92 2.98 4.48 2.98 7.21v79.91c0 5.65-4.59 10.25-10.22 10.25H16.5c-5.65 0-10.25-4.6-10.25-10.25Z",
    style: {
      fill: "url(#aggregate_responses-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.25 120.11c-1.23 1.23-3.25 1.19-4.41-.03L99.15 81.86l-9.28 9.41c-6.83 6.96-18.03 6.97-24.88 0l-9.28-9.41-37.69 38.22c-1.16 1.22-3.17 1.27-4.41.03a3.09 3.09 0 0 1-.03-4.41l37.75-38.28-35.58-36.09a3.105 3.105 0 0 1-.03-4.38c.62-.63 1.44-.94 2.22-.94s1.63.31 2.22.94l49.28 49.94c4.21 4.26 11.3 4.79 16.28-.28l48.79-49.48a3.123 3.123 0 0 1 4.26-.17 3.116 3.116 0 0 1 .18 4.54l-35.42 35.92 37.75 38.28a3.09 3.09 0 0 1-.03 4.41",
    style: {
      fill: "url(#aggregate_responses-01_svg2__d)"
    }
  })));
};
export default SvgAggregateResponses01;